import React from "react";

//@MUI
import { Button, Divider, Tab, Tabs, Typography } from "@material-ui/core";
import useStyles from "./ReviewsPageTool.styles.js";

//icons
import {
  CaretLeft,
  CheckCircle,
  CheckSquare,
  DotsThreeCircle,
  FilmStrip,
  PaintBrushHousehold,
  Users,
} from "phosphor-react";
import { Plus } from "react-feather";

//@components
import BreadCrumb from "../../Utilities/BreadCrumb/BreadCrumb.jsx";
import ExternalReviewerIcon from "../../Utilities/Svg/ExternalReviewerIcon.jsx";
import VRIcon from "../../Utilities/Svg/VRIcon.jsx";

function ReviewTools({
  handleManageReviewModal,
  setFilterCompleted,
  filterCompleted,
  handleReviewToggler,
  handleNewReviewModal,
  isReviewVersion,
  isExternalReviewer,
  parentReview,
  statusCount,
  filterStatus,
  setFilterStatus,
  handleToggleMultiSelect,
  handleOpenBulkMoveModal,
  isMultiSelectEnabled,
  handleClearSelection,
}) {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.root}>
        {!isMultiSelectEnabled ? (
          <div className={classes.divContainer}>
            <div className={classes.innerLeftContainer}>
              <ExternalReviewerIcon />
              <BreadCrumb shotCode={parentReview ? parentReview.name : ""} />
            </div>
            {isReviewVersion === "yes" ? (
              ""
            ) : (
              <Tabs
                value={filterCompleted}
                onChange={(event, value) => {
                  setFilterCompleted(value);
                }}
                style={{ marginTop: "-8px" }}
              >
                <Tab
                  value={"False"}
                  id="pending"
                  label={
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <DotsThreeCircle
                        style={{ marginRight: "10px" }}
                        size={18}
                      />
                      Pending
                    </div>
                  }
                />
                <Tab
                  value={"True"}
                  id="completed"
                  label={
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <CheckCircle style={{ marginRight: "10px" }} size={18} />
                      Completed
                    </div>
                  }
                />
                <Tab
                  value={"VR"}
                  id="VR"
                  label={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <VRIcon />
                      VR Sessions
                    </div>
                  }
                />
              </Tabs>
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <Button
              startIcon={<CaretLeft />}
              onClick={() => {
                handleToggleMultiSelect && handleToggleMultiSelect();
              }}
              className={classes.backButton}
            >
              Back
            </Button>
            <Button
              startIcon={<FilmStrip />}
              style={{ minWidth: "0px", padding: "4px 7px" }}
              onClick={() => handleOpenBulkMoveModal()}
            >
              <Typography className={classes.checkBoxText}>
                Move To Sequence
              </Typography>
            </Button>
            <Button
              startIcon={<PaintBrushHousehold />}
              style={{ minWidth: "0px", padding: "4px 7px" }}
              onClick={() => handleClearSelection()}
            >
              <Typography className={classes.checkBoxText}>
                Clear Selection
              </Typography>
            </Button>
          </div>
        )}
        <div className={classes.divContainer} id="toggle">
          {/* <ToggleButton handleToggler={handleReviewToggler} /> */}
          {isReviewVersion === "yes" && !isMultiSelectEnabled ? (
            <div className={classes.reviewVersionStatusFiltersContainer}>
              {[
                {
                  name: "In Progress",
                  value: statusCount?.in_progress,
                  slug: "in_progress",
                },
                {
                  name: "Approved",
                  value: statusCount?.approved,
                  slug: "approved",
                },
                {
                  name: "Rejected",
                  value: statusCount?.rejected,
                  slug: "rejected",
                },
              ]?.map((sin, index) => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: filterStatus === sin?.slug ? "white" : "#B1B5C9",
                    backgroundColor:
                      filterStatus === sin?.slug ? "#1B1D28" : "transparent",
                    padding: "6px 12px",
                    borderRadius: "5px",
                  }}
                  key={sin}
                  onClick={() => setFilterStatus(sin?.slug)}
                >
                  <span>{sin?.name}</span>
                  <span
                    style={{
                      backgroundColor:
                        filterStatus === sin?.slug ? "#6C65D9" : "#1B1D28",
                      padding: "2px 6px",
                      borderRadius: "5px",
                      height: "22px",
                      minWidth: "22px",
                    }}
                  >
                    {sin?.value || 0}
                  </span>
                </div>
              ))}
            </div>
          ) : null}
          {!isExternalReviewer && !isMultiSelectEnabled && (
            <>
              {isReviewVersion === "yes" && (
                <Button
                  startIcon={<CheckSquare />}
                  style={{ minWidth: "0px", padding: "4px 7px" }}
                  onClick={() =>
                    handleToggleMultiSelect && handleToggleMultiSelect()
                  }
                >
                  <Typography className={classes.checkBoxText}>
                    Multi Select
                  </Typography>
                </Button>
              )}
              <Button
                className={classes.manageReviewBtn}
                startIcon={<Users size={18} />}
                onClick={handleManageReviewModal}
              >
                Manage Reviewer
              </Button>
              <Button
                className={classes.addReviewBtn}
                startIcon={<Plus size={19} />}
                onClick={handleNewReviewModal}
              >
                {isReviewVersion === "yes" ? "Add to Version" : "Add to Review"}
              </Button>
            </>
          )}
        </div>
      </div>
      <Divider className={classes.divider} />
    </div>
  );
}

export default ReviewTools;

// ReviewTools.propTypes = {
//
// };
